<div class="custom-overlay-container  {{ rootScope.customDialogData.customClass }}" id="customDialog">
  <div class="custom-overlay-body">
    <div class="custom-overlay-content" role="dialog">

      <div id="content">
        <h6 *ngIf="rootScope.customDialogData.heading !== 'NA'" class="custom-model-heading">
          {{ rootScope.customDialogData.heading }}
        </h6>
        <p>
          {{ rootScope.customDialogData.msg }}
        </p>
        <p *ngIf="rootScope.customDialogData.msg2">
          {{rootScope.customDialogData.msg2 ? rootScope.customDialogData.msg2 : ''}}
        </p>
        <div class="custom-overlay-footer">
          <f-button *ngIf="rootScope.customDialogData.buttonLabel1" [title]="rootScope.customDialogData.buttonLabel1" [text]="rootScope.customDialogData.buttonLabel1"
            tabindex="1" type="button" variant="action"
            (buttonClicked)="
              buttonClicked(rootScope.customDialogData.buttonLabel1)
            "></f-button>

          <f-button *ngIf="rootScope.customDialogData.buttonLabel2" [title]="rootScope.customDialogData.buttonLabel2" [text]="rootScope.customDialogData.buttonLabel2"
            tabindex="1" type="button" uuid="btn2"
            variant="progressive" (buttonClicked)="
              buttonClicked(rootScope.customDialogData.buttonLabel2)
            "></f-button>
        </div>
      </div>
    </div>
  </div>
</div>